import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import Swal from "sweetalert2";
import { api_otp } from "../../api/auth";

const VerificationPhone = ({
  onSelectedValueChange,
  updateOtpMatch,
  handlePhoneChange,
  otp = null,
  phone = null,
  selectedCountry = null,
  emailCodeStatus,
  handleSubmitAndSaveEmail,
  formErrorMessage,
}) => {
  const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ phone: "" });
  const [apiOtp, setApiOtp] = useState(otp);
  const [disableApiOtp, setDisableApiOtp] = useState(false);

  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const [otpMatch, setOtpMatch] = useState(false);

  const [countdown, setCountdown] = useState(5);
  const [showResendOtp, setShowResendOtp] = useState(false);

  const searchCountryCode = (option, inputValue) => {
    return option?.data?.code?.includes(inputValue);
  };

  const handle_verify_otp = async (e) => {
    let _otp = otp ?? apiOtp;
    e.preventDefault();
    const otp_value = otpValues.join("");
    if (otp_value == _otp && otp_value != "") {
      setOtpMatch(true);
      updateOtpMatch(true);
    } else {
      Swal.fire({
        icon: "error",
        title: "OTP",
        text: "OTP does not match!",
      });
    }
  };

  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  const handleInputChange = (event, index) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "phone") {
      handlePhoneChange(value);
    } else {
      const newOtpValues = [...otpValues];
      newOtpValues[index] = value;
      setOtpValues(newOtpValues);

      if (index < 3 && value) {
        if (inputRefs[index + 1] && inputRefs[index + 1].current) {
          inputRefs[index + 1].current.focus();
        }
      }
    }
  };

  useEffect(() => {
    if (apiOtp) {
      setShowResendOtp(true);
      const interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [apiOtp]);

  const generateRandomDigit = () => {
    const min = 1000;
    const max = 9999;
    const randomDigit = Math.floor(Math.random() * (max - min + 1)) + min;
    return randomDigit;
  };

  const handle_send_code = async () => {
    const otp_code = generateRandomDigit();

    return await api_otp(otp_code, formData.phone)
      .then((data) => {
        if (data.status == true) {
          Swal.fire({
            icon: "success",
            title: "twilio testing acc",
            text: `OTP: ${data.otp_code}`,
            iconColor: "#39B5B2", // for success
          });

          setShowResendOtp(true);
          setIsLoading(true);
          setDisableApiOtp(true);
          setCountdown(5);
          setApiOtp(data.otp_code);
        } else {
          Swal.fire({
            icon: "error",
            title: "twilio testing acc",
            text: data.message,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    fetch("https://restcountries.com/v2/all")
      .then((response) => response.json())
      .then((data) => {
        const countries = data.map((country) => ({
          image: country.flags.svg,
          code: country.callingCodes[0],
        }));

        setCountries(countries);
        setIsLoading(false);
        const defaultCountry = countries.find(
          (country) => country.code === "60"
        );
        if (defaultCountry) {
          onSelectedValueChange(defaultCountry);
        }
      })
      .catch((error) => console.error("Error:", error));
  }, []);

  const handleCountryChange = (selectedOption) => {
    onSelectedValueChange(selectedOption);
  };

  return (
    <>
      <div
        className="type_phone_number"
        style={{
          backgroundColor: "white",
          padding: "10px",
          borderRadius: "10px",
          width: "100%",
        }}
      >
        <div>
          <label htmlFor="PhoneNumber" style={{ color: "black" }}>
            Phone Number
          </label>
        </div>

        <div className="country_no">
          <Select
            value={selectedCountry}
            options={countries}
            styles={{
              control: (provided) => ({
                ...provided,
                width: "120px",
                border: "none",
              }),
              option: (provided) => ({
                ...provided,
                color: "black",
                backgroundColor: "white",
              }),
              indicatorsContainer: (provided) => ({
                ...provided,
                padding: "0",
              }),
            }}
            formatOptionLabel={(country) => {
              return (
                <div className="country-option">
                  <img
                    src={country.image}
                    alt="country-image"
                    style={{
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                    }}
                  />
                  <span>+{country.code}</span>
                </div>
              );
            }}
            onChange={(selectedOption) => handleCountryChange(selectedOption)}
            isSearchable={true}
            filterOption={searchCountryCode}
          />
          <input
            type="text"
            className="phone w-100"
            name="phone"
            placeholder="eg.12345678"
            onChange={handleInputChange}
            value={phone}
            style={{ border: "none" }}
          />
        </div>
        {formErrorMessage && (
          <div style={{ textAlign: "left" }}>
            <p
              style={{
                fontSize: "12px",
                color: "red",
                marginTop: "3px",
                marginBottom: "0",
                width: "100%",
                lineHeight: "15px",
                opacity: formErrorMessage ? 1 : 0,
                transition: "opacity 0.5s ease",
                transitionDelay: "1s",
              }}
            >
              *{formErrorMessage}
            </p>
          </div>
        )}
      </div>

      <div
        style={{ marginInline: "5px", marginTop: "10px", textAlign: "left" }}
      >
        {otpMatch ? (
          <i className="fas fa-check"></i>
        ) : emailCodeStatus == "sent" ? (
          <>
            <span>
              Please check your email inbox for the verification code.
            </span>
            <br />
            <span>
              Haven't received code?{" "}
              <a className="send_code" onClick={handleSubmitAndSaveEmail}>
                Resend{" "}
              </a>
            </span>
          </>
        ) : emailCodeStatus == "sending" ? (
          <span className="send_code">Sending...</span>
        ) : (
          <a className="send_code" onClick={handleSubmitAndSaveEmail}>
            Send Code
          </a>
        )}
      </div>

      <div className="phone_number_otp">
        <label htmlFor="otp">
          {[0, 1, 2, 3].map((index) => (
            <input
              ref={inputRefs[index]}
              id={`otp_${index}`}
              key={index}
              type="text"
              name={`otp${index}`}
              maxLength={1}
              onChange={(e) => handleInputChange(e, index)}
            />
          ))}
        </label>
      </div>

      <div className="phone_number_code d-none">
        {showResendOtp && countdown > 0 ? (
          <div>
            <p>Resend after {countdown} seconds</p>
          </div>
        ) : (
          <div>
            <p style={{ color: "black" }}>
              Haven't received code?{" "}
              <a
                className="resend_code"
                onClick={handle_send_code}
                style={{ color: "#967F65" }}
              >
                Resend
              </a>
            </p>
          </div>
        )}
      </div>

      <div className="phone_number_button">
        <button onClick={handle_verify_otp}>Verify</button>
      </div>
    </>
  );
};

export default VerificationPhone;
